import _ from "lodash";

type TransformObjParam = {
  mainKey: string;
  data: object;
  mainIdx?: number;
  customKeyForm?: (input: { mainKey: string; key: string; mainIdx?: number; idx: number }) => string;
};

type TransformObjParamInArr = {
  mainKey: string;
  data: object;
  mainIdx: number;
  customKeyForm?: (input: { mainKey: string; key: string; mainIdx: number; idx: number }) => string;
};

type TransformArrParam = {
  mainKey: string;
  data: any[];
  helper?: {
    handelObject?: (data: TransformObjParamInArr) => { [formKey: string]: any };
  };
};

export const FormDataUtil = {
  convertJsonToFormData,
  transformObjectFormData,
  transformArrayFormData,
  logFormData,
};

function convertJsonToFormData(
  data: { [key: string]: any },
  helper?: {
    handelObject?: (input: TransformObjParam) => { [formKey: string]: any };
    handelObjectInArr?: (input: TransformObjParamInArr) => { [formKey: string]: any };
    handelArray?: (input: Omit<TransformArrParam, "helper">) => { [formKey: string]: any };
  }
): FormData {
  const formData = new FormData();
  const dataArr = Object.entries(data);
  const handelArray = helper?.handelArray || transformArrayFormData;
  const mapObjectToFormData = (obj: object) => {
    Object.entries(obj).forEach(([key, value], i) => {
      formData.append(key, value);
    });
  };

  dataArr.forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      // handle append multiple photos
      if (key === "photos" && Array.isArray(value)) {
        value.forEach((photo) => formData.append("photos", photo));
      } else if (Array.isArray(value)) {
        let temp = handelArray({ mainKey: key, data: value, helper: { handelObject: helper?.handelObjectInArr } });
        mapObjectToFormData(temp);
      } else if (_.isPlainObject(value) && helper?.handelObject) {
        const temp = helper.handelObject({ mainKey: key, data: value });
        mapObjectToFormData(temp);
      } else formData.append(key, value);
    }
  });

  return formData;
}

/**
 * mainKey: key in main object in form data
 *
 * chưa kiểm tra được những object có deep
 */
function transformObjectFormData(input: TransformObjParam): { [formKey: string]: any } {
  const temp: { [key: string]: any } = {};

  Object.entries(input.data).forEach(([k, v], i) => {
    let prop: string = `${input.mainKey}[${i}][${k}]`;
    if (input.customKeyForm) {
      prop = input.customKeyForm({ mainKey: input.mainKey, key: k, idx: i, mainIdx: input.mainIdx });
    }

    temp[prop] = v;
  });

  return temp;
}

function transformArrayFormData(input: TransformArrParam): { [formKey: string]: any } {
  let temp: { [key: string]: any } = {};
  const transformObj = input.helper?.handelObject || transformObjectFormData;

  input.data.forEach((val, i) => {
    if (input.mainKey === "photo") {
      temp[`${input.mainKey}[]`] = val;
    } else if (_.isPlainObject(val)) {
      const tempObj = transformObj({ mainKey: input.mainKey, data: val, mainIdx: i });
      temp = { ...temp, ...tempObj };
    } else {
      temp[`${input.mainKey}[${i}]`] = val;
    }
  });

  return temp;
}

function logFormData(form: FormData) {
  const arr: any = form.entries();

  for (let pair of arr) {
    console.log(pair[0] + " - " + pair[1]);
  }
}
